import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import WhySection from "@/components/WhySection";
import WhoSection from "@/components/WhoSection";
import JourneyPreview from "@/components/JourneyPreview";
import FAQ from "@/components/FAQ";
import CTA from "@/components/CTA";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import { useLanguage } from "@/contexts/LanguageContext";
import { organizationSchema, websiteSchema, localBusinessSchema } from "@/lib/structuredData";

const Index = () => {
  const { t, language } = useLanguage();

  const homeStructuredData = {
    "@context": "https://schema.org",
    "@graph": [organizationSchema, websiteSchema, localBusinessSchema]
  };
  
  return (
    <div className="min-h-screen bg-decorative bg-pattern scroll-smooth">
      <SEO
        title={language === 'nl' 
          ? "Toegankelijkheid Expert | EqualAccess B.V. - Digitale Toegankelijkheid & WCAG" 
          : "Accessibility Expert | EqualAccess B.V. - Digital Accessibility & WCAG"}
        description={language === 'nl'
          ? "Toegankelijkheid specialist voor websites en apps. Expert begeleiding voor digitale toegankelijkheid, WCAG compliance en EU Toegankelijkheidswet. Maak uw website toegankelijk."
          : "Accessibility specialist for websites and apps. Expert guidance for digital accessibility, WCAG compliance and EU Accessibility Act. Make your website accessible."}
        keywords={language === 'nl'
          ? "toegankelijkheid, digitale toegankelijkheid, website toegankelijkheid, WCAG, EU Toegankelijkheidswet, accessibility, toegankelijke website"
          : "accessibility, digital accessibility, website accessibility, WCAG, EU Accessibility Act, accessible website"}
        canonicalUrl="https://equalaccess.nl/"
        structuredData={homeStructuredData}
      />
      {/* Skip to main content link for keyboard users */}
      <a 
        href="#main-content" 
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-accent focus:text-accent-foreground focus:rounded-md focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
      >
        {t('nav.skipToMain')}
      </a>
      <Navbar />
      <main id="main-content" tabIndex={-1}>
        <Hero />
        <div className="relative z-10 bg-background shadow-[0_0_100px_rgba(0,0,0,0.1)] border-t border-border/20">
          <WhySection />
          <WhoSection />
          <JourneyPreview />
          <FAQ />
          <CTA />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Index;
